import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import { dateFormatTimestampFromArray } from 'helpers/dateFormat/dateFormat'
import LessonCodesListItem from './lesson_codes_list_item'

import styles from './lesson_codes_list.scss'

class LessonCodesList extends PureComponent {

	constructor() {
		super()
		this.state = {
			calendarOpened: false,
			selectedSessionUid: '',
			temporaryExpireTime: '',
		}
		this.handleSaveExpirationDate = this.handleSaveExpirationDate.bind(this)
		this.handleCancelDate = this.handleCancelDate.bind(this)
		this.handleCalendarSelection = this.handleCalendarSelection.bind(this)
		this.closeCalendar = this.closeCalendar.bind(this)
		this.openCalendar = this.openCalendar.bind(this)
		this.handleToggleCode = this.handleToggleCode.bind(this)
		this.handleDateSelection = this.handleDateSelection.bind(this)
		this.dateChangeHandler = this.dateChangeHandler.bind(this)
	}

	closeCalendar() {
		this.setState({
			temporaryExpireTime: '',
			calendarOpened: false,
		})
	}

	openCalendar(expireTime) {
		this.setState({
			temporaryExpireTime: expireTime,
			calendarOpened: true,
		})
	}

	handleToggleCode(sessionUid) {
		this.updateSessionUid(this.state.selectedSessionUid !== sessionUid ? sessionUid : '')
		this.closeCalendar()
	}

	updateSessionUid(sessionUid) {
		this.setState({
			selectedSessionUid: sessionUid,
		})
		this.props.handleOnChangeSessionUid(sessionUid)
	}

	focusOnCalendar(sessionUid, expireTime) {
		this.openCalendar(expireTime)
		this.updateSessionUid(sessionUid)
	}

	handleCalendarSelection(sessionUid, expireTime) {
		if (!this.state.calendarOpened || this.state.selectedSessionUid !== sessionUid) {
			this.focusOnCalendar(sessionUid, expireTime)
		} else {
			this.closeCalendar()
		}
	}

	handleSaveExpirationDate() {
		const currentCode = this.props.codes.find(code => code.session_uid === this.state.selectedSessionUid)
		this.props.handleSaveExpirationDate(this.state.selectedSessionUid, this.state.temporaryExpireTime, currentCode.expire_time)
		this.closeCalendar()
	}

	handleCancelDate() {
		this.closeCalendar()
	}

	dateChangeHandler(expireTime) {
		this.setState({
			temporaryExpireTime: dateFormatTimestampFromArray(expireTime),
		})
	}

	handleDateSelection(sessionUid, expireTime) {
		if (this.props.canChangeExpirationDate) {
			this.handleCalendarSelection(sessionUid, expireTime)
		} else {
			this.handleToggleCode()
		}
	}

	scrollToView = (element, sessionUid) => {
		if (element && this.state.calendarOpened && this.state.selectedSessionUid === sessionUid) {
			element.scrollIntoView()
		}
	}

	renderCodesList() {
		const codesList = this.props.codes.map(code => {
			const isSelected = this.state.selectedSessionUid === code.session_uid
			const expireTime = isSelected && this.state.temporaryExpireTime ? this.state.temporaryExpireTime : code.expire_time
			const codeObject = {
				launchedTime: code.launched_time,
				pincode: code.pincode,
				sessionUid: code.session_uid,
				expireTime,
				isSelected,
			}
			return (
				<div
					key={code.pincode}
					ref={ element => this.scrollToView(element, code.session_uid)}
				>
					<LessonCodesListItem
						code={codeObject}
						canChangeExpirationDate={this.props.canChangeExpirationDate}
						dateText={this.props.dateText}
						isSelectable={this.props.isSelectable}
						hasCalendarActive={this.state.calendarOpened && isSelected}
						handleDateSelection={this.handleDateSelection}
						handleToggleCode={this.handleToggleCode}
						dateChangeHandler={this.dateChangeHandler}
						actualTimestamp={this.props.actualTimestamp}
						handleSaveExpirationDate={this.handleSaveExpirationDate}
						handleCancelDate={this.handleCancelDate}
					/>
				</div>
			)
		})
		return codesList
	}

	render() {
		return (
			<ul styleName='code-list'>
				<li styleName='code-list-header'>
					<p styleName='code-list-header-column'>{this.props.dateTitle}</p>
					<p styleName='code-list-header-column'>{this.props.codeTitle}</p>
					<p styleName='code-list-header-column'>{this.props.expirationTitle}</p>
				</li>
				{this.renderCodesList()}
			</ul>
		)
	}
}

LessonCodesList.propTypes = {
	codes: PropTypes.array,
	dateTitle: PropTypes.string,
	codeTitle: PropTypes.string,
	expirationTitle: PropTypes.string,
	isSelectable: PropTypes.bool,
	dateText: PropTypes.string,
	handleSaveExpirationDate: PropTypes.func,
	canChangeExpirationDate: PropTypes.bool,
	handleOnChangeSessionUid: PropTypes.func,
	actualTimestamp: PropTypes.number,
}

LessonCodesList.defaultProps = {
	codes: [],
	dateTitle: 'Launched on',
	codeTitle: 'CODE',
	expirationTitle: 'Expires in',
	isSelectable: false,
	dateText: '',
	canChangeExpirationDate: false,
	handleSaveExpirationDate: () => {},
	handleOnChangeSessionUid: () => {},
	actualTimestamp: 0,
}

export default CSSModules(LessonCodesList, styles, {allowMultiple: true})
